import React, {useEffect, useState} from "react";
import {
  ModalBackButton,
  ModalContainer,
} from "../../common/components/modules/modal/modalComponents";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import useRouter from "../../common/hooks/useRouter";
import ChangePasswordForm from "./ChangePasswordForm";
import ChangePasswordBuilder from "../../authentication/components/changePasswordBuilder";
import * as Notifications from "src/core/notifications";
import Modal from "../../common/components/modules/modal/Modal";
import Title from "src/core/common/components/modules/Title";

function ChangePassword({isOpen, closeModal}) {
  const [authState, authApi] = useAuthentication();
  const router = useRouter();
  const [requested, setRequested] = useState(false);
  const [builder] = useState(new ChangePasswordBuilder());

  const finish = () => {
    setRequested(true);
    authApi.changePassword(builder.build());
  };

  const {loading, error} = authState;
  /* eslint-disable */
  useEffect(() => {
    if (!loading && requested && !error) {
      Notifications.success("Password changed successfully.");
      router.safeBack();
    }
  }, [error, loading, router]);
  /* eslint-enable */

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <ModalBackButton onClick={() => router.safeBack()} />
      <ModalContainer>
        <Title>Change Password</Title>
        <ChangePasswordForm builder={builder} onFinish={finish} />
      </ModalContainer>
    </Modal>
  );
}

export default ChangePassword;
